import { Colors } from '@sigma-frontend-libs/commons'

import { breakpoints, buttonModes, components, getServiceComponent, icons, states } from '@/utils'

import button from '@/components/button'
import buttonConfirmRemove from '@/components/button/confirm/remove'
import buttonFavorite from '@/components/button/favorite'
import componentNotFound from '@/components/misc/componentNotFound'
import FormTitle from '@/components/misc/FormTitle'
import preloader from '@/components/preloader'

function renderFormTitle(h, options) {
  return h(
    FormTitle,
    {
      props: {
        value: this.restData[options.name].get.data,
        errors: this.restData[options.name].update.errors
      },
      on: {
        input: event => {
          this.restData[options.name].get.data = event
        },
        submit: () => {
          this.update()
        },
        validation: event => {
          this.titleValidation = event
        }
      }
    }
  )
}
function renderTitleSlot(h, options) {
  if (this.$scopedSlots.title) {
    return this.$scopedSlots.title({
      data: this.restData[options.name].get.data,
      validation: this.validation,
      setData: event => {
        this.restData[options.name].get.data = event
      },
      setTitleValidation: event => {
        this.titleValidation = event
      }
    })
  }

  return this.$slots.title
}
function renderHeaderSlot(h, options) {
  if (this.$scopedSlots.header) {
    return this.$scopedSlots.header({ data: this.restData[options.name].get.data })
  }

  return this.$slots.header
}
function renderHeader(h, options) {
  return h(
    'div',
    {
      class: 'legacy-template__header'
    },
    [
      renderTitleSlot.call(this, h, options) ?? renderFormTitle.call(this, h, options),
      renderHeaderSlot.call(this, h, options)
    ]
  )
}
function renderAfterTitle(h, options) {
  if (this.$scopedSlots.afterTitle) {
    return this.$scopedSlots.afterTitle({ data: this.restData[options.name].get.data })
  }

  return this.$slots.afterTitle
}

function renderFormComponent(h, options) {
  try {
    return h(
      getServiceComponent(`${options.name}/form`),
      {
        props: {
          value: this.restData[options.name].get.data,
          errors: this.restData[options.name].update.errors,
          saveSuccessKey: this.updateSuccessKey
        },
        on: {
          input: event => {
            this.restData[options.name].get.data = event
          },
          submit: () => {
            this.update()
          },
          validation: event => {
            this.formValidation = event
          }
        }
      }
    )
  } catch (error) {
    return h(componentNotFound)
  }
}
function renderAfterForm(h, options) {
  if (this.$scopedSlots['after-form']) {
    return this.$scopedSlots['after-form']({ data: this.restData[options.name].get.data })
  }

  return this.$slots['after-form']
}
function renderForm(h, options) {
  return h(
    components.card,
    {
      class: 'pb-3',
      props: {
        rounded: true,
        outline: true
      }
    },
    [
      renderFormComponent.call(this, h, options),
      renderAfterForm.call(this, h, options)
    ]
  )
}

function renderCloseButton(h, options) {
  return h(
    button,
    {
      props: {
        mode: buttonModes.flat,
        label: this.getTranslate('misc.buttons.close')
      },
      on: {
        click: () => {
          this.$router.push({ name: options.name })
        }
      }
    }
  )
}
function renderFavoriteButton(h, options) {
  return h(
    buttonFavorite,
    {
      props: {
        id: this.restData[options.name].get.data.id,
        service: options.name
      }
    }
  )
}
function renderButtonsPlaceholder(h) {
  return h(
    'div',
    {
      class: 'legacy-template__buttons-placeholder'
    }
  )
}
function renderButtonsSlot(h, options) {
  if (this.$scopedSlots.buttons) {
    return this.$scopedSlots.buttons({ data: this.restData[options.name].get.data })
  }

  return this.$slots.buttons ?? renderButtonsPlaceholder.call(this, h)
}
function renderRefreshButton(h, options) {
  return h(
    button,
    {
      props: {
        icon: icons.refresh,
        mode: buttonModes.flat,
        loading: this.restData[options.name].get.state === states.loading,
        disabled: this.restData[options.name].get.state === states.loading || !this.canGet
      },
      on: {
        click: () => {
          this.getById()
        }
      }
    }
  )
}
function renderRemoveButton(h, options) {
  return h(
    buttonConfirmRemove,
    {
      props: {
        labeled: false,
        loading: this.restData[options.name].remove.state === states.loading,
        disabled: this.restData[options.name].remove.state === states.loading || !this.canRemove,
        callback: () => {
          return this.rest[options.name].remove(this.restData[options.name].get.data.id)
        }
      }
    }
  )
}
function renderUpdateButton(h, options) {
  return h(
    button,
    {
      props: {
        label: this.getTranslate('misc.buttons.update'),
        loading: this.restData[options.name].update.state === states.loading,
        disabled: this.updateDisabled,
        mode: buttonModes.filled,
        color: Colors.primary
      },
      on: {
        click: () => {
          this.update()
        }
      }
    }
  )
}
function renderFooter(h, options) {
  return h(
    'div',
    {
      class: 'legacy-template__footer'
    },
    [
      renderCloseButton.call(this, h, options),
      renderFavoriteButton.call(this, h, options),
      renderButtonsSlot.call(this, h, options),
      renderRefreshButton.call(this, h, options),
      renderRemoveButton.call(this, h, options),
      renderUpdateButton.call(this, h, options)
    ]
  )
}

function renderLeftCol(h, options) {
  if (this.$route.params.id) {
    if (this.canGet) {
      switch (this.restData[options.name].get.state) {
        case states.ready: {
          if (this.restData[options.name].get.data) {
            return h(
              'div',
              {
                class: 'legacy-template__column'
              },
              [
                renderHeader.call(this, h, options),
                renderAfterTitle.call(this, h, options),
                renderForm.call(this, h, options),
                renderFooter.call(this, h, options)
              ]
            )
          } else {
            return h(components.empty)
          }
        }
        case states.loading: {
          return h(
            'div',
            {
              class: 'preloader__holder pa-5'
            },
            [ h(preloader) ]
          )
        }
        default: return h(components.empty)
      }
    }
  }
}

function renderRightSlot(h, options) {
  if (this.$scopedSlots.right) {
    return this.$scopedSlots.right({ data: this.restData[options.name].get.data })
  }

  return this.$slots.right
}
function renderRightCol(h, options) {
  if (this.$route.params.id) {
    const data = this.restData[options.name].get.data
    if (this.restData[options.name].get.state === states.ready && data) {
      return renderRightSlot.call(this, h, options) ?? h('div')
    }
  }
}

function renderEmpty(h) {
  return h(
    'div',
    {
      class: {
        'legacy-template': true,
        'legacy-template--empty': true
      }
    },
    [
      h(
        'div',
        {
          class: 'legacy-template__empty'
        },
        [ h(components.empty) ]
      )
    ]
  )
}

function renderContent(h, options) {
  return h(
    'div',
    {
      class: 'legacy-template'
    },
    [
      renderLeftCol.call(this, h, options),
      renderRightCol.call(this, h, options)
    ]
  )
}

export default function(h, options) {
  if (this.$route.params.id) {
    return renderContent.call(this, h, options)
  }

  if (this.viewport.size.width > breakpoints.md) {
    return renderEmpty.call(this, h)
  }

  return h()
}
